// Deployed dev/staging (DigitalOcean, voyager2-dev, etc.). Selected via `ng build --env=dev` / `npm run build:dev`.
export const environment = {
  production: false,
  apiUrl: '/CI',
  apiEndpoint: 'https://voyagerapi-dev.equityestatesfund.com/api/',
  serverUrl: 'https://voyagerapi-dev.equityestatesfund.com/',
  serverHost: 'voyagerapi-dev.equityestatesfund.com',
  calendarHost: 'voyagercalendar-dev1.equityestatesfund.com',
  basisTheoryEnvironment: 'test',
  useLocalWebSocket: false,
  version: '4.0.2',
  environment: 'development',
  // Assistant service for the member chat. Empty = the chat is off in that environment.
  assistantUrl: 'https://voyager-agent-dev-6sli2.ondigitalocean.app'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts